export type ApiKeyStatus = 'active' | 'revoked' | 'expired';

export interface ApiKeyStatusFields {
  revokedAt: string | null;
  isActive: boolean;
  expiresAt: string | null;
}

export function getKeyStatus(key: ApiKeyStatusFields): ApiKeyStatus {
  if (key.revokedAt || !key.isActive) return 'revoked';
  if (key.expiresAt && new Date(key.expiresAt) < new Date()) return 'expired';
  return 'active';
}
